import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "type", "size", "elementRef", "as", "interaction", "color", "margin", "cursor", "href", "renderIcon"];
var _dec, _dec2, _class, _CondensedButton;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { testable } from '@instructure/ui-testable';
import { passthroughProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import generateComponentTheme from './theme';
import { BaseButton } from '../BaseButton';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
// needed for listing the available theme variables on docs page
let CondensedButton = (_dec = withStyle(null, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_CondensedButton = class CondensedButton extends Component {
  constructor(...args) {
    super(...args);
    this._baseButton = null;
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  get focused() {
    return this._baseButton && this._baseButton.focused;
  }
  focus() {
    this._baseButton && this._baseButton.focus();
  }
  render() {
    const _this$props = this.props,
      children = _this$props.children,
      type = _this$props.type,
      size = _this$props.size,
      elementRef = _this$props.elementRef,
      as = _this$props.as,
      interaction = _this$props.interaction,
      color = _this$props.color,
      margin = _this$props.margin,
      cursor = _this$props.cursor,
      href = _this$props.href,
      renderIcon = _this$props.renderIcon,
      props = _objectWithoutProperties(_this$props, _excluded);
    const themeOverride = this.props.themeOverride;
    return _jsx(BaseButton, {
      ...passthroughProps(props),
      isCondensed: true,
      withBackground: false,
      withBorder: false,
      type: type,
      size: size,
      elementRef: this.handleRef,
      as: as,
      interaction: interaction,
      color: color,
      margin: margin,
      cursor: cursor,
      href: href,
      renderIcon: renderIcon,
      themeOverride: themeOverride,
      ref: component => {
        this._baseButton = component;
      },
      children: children
    });
  }
}, _CondensedButton.displayName = "CondensedButton", _CondensedButton.componentId = 'CondensedButton', _CondensedButton.propTypes = propTypes, _CondensedButton.allowedProps = allowedProps, _CondensedButton.defaultProps = {
  type: 'button',
  size: 'medium',
  as: 'button',
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  color: 'primary',
  margin: '0',
  cursor: 'pointer'
}, _CondensedButton)) || _class) || _class);
export default CondensedButton;
export { CondensedButton };